var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap flex-col md:flex-row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "w-full md:w-1/4 md:text-right mb-5 md:mb-0" }, [
        _c(
          "a",
          {
            staticClass: "button mb-12",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.exportResources.apply(null, arguments)
              },
            },
          },
          [_vm._v("Export Resources")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-full md:w-1/4 md:text-right mb-5 md:mb-0" }, [
        _c(
          "a",
          {
            staticClass: "button mb-12",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.syncResources.apply(null, arguments)
              },
            },
          },
          [_vm._v("Sync Resources")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "flex-1 mb-3" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword",
            },
          ],
          staticClass: "mb-4 search",
          attrs: {
            type: "text",
            placeholder:
              "Search title, creator user first name/last name, organization name",
          },
          domProps: { value: _vm.keyword },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.search.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.keyword = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-full md:w-1/5" }, [
        _c(
          "button",
          {
            staticClass: "button mb-2",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.search.apply(null, arguments)
              },
            },
          },
          [_vm._v("Search")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-full md:w-1/5" }, [
        _c(
          "button",
          {
            staticClass: "button mb-2",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.clearSearch.apply(null, arguments)
              },
            },
          },
          [_vm._v("Clear")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "responsive-table" }, [
      _c("table", { staticClass: "w-full" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          [
            this.isSearching && this.searchedResources.length < 1
              ? _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center font-bold",
                      attrs: { colspan: "5" },
                    },
                    [_vm._v("No search results")]
                  ),
                ])
              : _vm._l(_vm.filteredResources, function (resource) {
                  return _c("admin-table-item", {
                    key: resource.id,
                    attrs: { resource: resource },
                  })
                }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex mt-8" }, [
        _c("div", { staticClass: "w-1/2" }, [
          _c(
            "button",
            {
              staticClass: "mt-2",
              class: { "opacity-50 cursor-not-allowed": _vm.currentPage === 1 },
              attrs: { disabled: _vm.currentPage === 1 },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.previous.apply(null, arguments)
                },
              },
            },
            [_vm._v("<< Previous")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "w-1/2 text-right" }, [
          _c(
            "button",
            {
              staticClass: "mt-2",
              class: {
                "opacity-50 cursor-not-allowed":
                  _vm.currentPage === _vm.totalPages,
              },
              attrs: { disabled: _vm.currentPage === _vm.totalPages },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.next.apply(null, arguments)
                },
              },
            },
            [_vm._v("Next >>")]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-full md:w-1/4 md:text-right mb-5 md:mb-0 mt-5" },
      [
        _c(
          "router-link",
          { staticClass: "button mb-12", attrs: { to: "/resources/create" } },
          [_vm._v("Create New Resource")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-full md:w-1/2" }, [
      _c(
        "h1",
        { staticClass: "mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark" },
        [_vm._v("All Resources")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", [_vm._v("Creating User, Organization")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }